import localStorageTemplates from 'common/local-storage-templates';
import { getFromLocalStorage } from 'utils/saveToLocalStorage';

export default currentChannel => {
  let conversationsDisbaledList = JSON.parse(
    getFromLocalStorage(localStorageTemplates.disabledConversation) || '[]'
  );
  let isDisabled = conversationsDisbaledList.find(channelId => channelId === currentChannel);
  return isDisabled ? true : false;
};
